import { dateFormatConfig } from '@/i18n';
import { useLanguageDirection } from './useLanguageDirection';

export const useDateFormatter = () => {
  const { language } = useLanguageDirection();
  const currentLanguage = language;
  const config = dateFormatConfig[currentLanguage] || dateFormatConfig.en;

  const formatDate = (
    date: Date,
    format: 'short' | 'medium' | 'long'
  ): string => {
    const formatOptions: Record<string, Intl.DateTimeFormatOptions> = {
      short: {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      },
      medium: {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      },
      long: {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      },
    };

    const options = formatOptions[format] || formatOptions.medium;
    const locale = currentLanguage === 'he' ? 'he-IL' : 'en-US';

    return date.toLocaleDateString(locale, options);
  };

  const getWeekDays = (): string[] => {
    return config.shortDays;
  };

  const getMonths = (): string[] => {
    return config.months;
  };

  const getWeekStart = (): number => {
    return config.weekStartsOn;
  };

  return {
    formatDate,
    getWeekDays,
    getMonths,
    getWeekStart,
    language: currentLanguage,
  };
};
